<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-self: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                v-bind="attrs"
                v-on="on"
                :loading="buttonLoading"
              >
                <v-icon>cloud_download</v-icon>export
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="reprintStockReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>
            Filter<v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseIds"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.productIds"
                :items="selectedProductList"
                label="Product"
                @click="showProducts()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.categoryIds"
                :items="categoryList"
                label="Category"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="poStockReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.productCode }}</td>
              <td>{{ props.item.productName }}</td>
              <td>
                {{ props.item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td>{{ props.item.stockQty | decFormat(6) }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">Purchase Income Stock Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Category : {{ filterCategory }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Location
              </th>
              <th style="border: 1px solid black; text-align: center">
                Stock No
              </th>
              <th style="border: 1px solid black; text-align: center">Name</th>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody
            v-for="(poStockReport, index) in allPOStockReportList"
            :key="index"
          >
            <tr v-for="(item, i) in poStockReport.poStockDetailList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.warehouseName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSecond | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.stockQty | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="4"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="4"
              >
                {{ poStockReport.subTotalQty | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="productQueryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedProductList"
                :headers="productHeaders"
                :items="productList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="producttotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="productpagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedProductList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setProduct">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { productService } from "../../services/product-service";
import { purchaseOrderService } from "../../services/purchase-order-service";
import { warehouseService } from "../../services/warehouse-service";
import { categoryService } from "../../services/category-service";

export default {
  name: "POStockReport",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showProductListDialog: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Purchase Income Stock Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Location", align: "left", value: "warehouseName" },
      { text: "Stock No", align: "left", value: "productCode" },
      { text: "Name", align: "left", value: "productName" },
      { text: "Date", align: "left", value: "issueDate" },
      { text: "Quantity", value: "qty" },
    ],
    productHeaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    productList: [],
    warehouseList: [],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      warehouseIds: [],
      productIds: [],
      categoryIds: [],
    },
    poStockReportList: [],
    allPOStockReportList: [],

    clonequeryParams: new Object(),
    activeCustomerList: [],
    productQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
    },
    productpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    producttotalRows: 0,
    selectedProductList: [],
    categoryList: [],
    filterCategory: "ALL",
  }),
  watch: {
    pagination: {
      handler() {
        this.getPOStockReport();
      },
      deep: true,
    },
    productpagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.warehouseIds = [this.user.warehouseId];
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCategoriesByStatus();
    this.getWarehouseList();
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "po-stock-report",
        query: this.queryParams,
      });
      this.getPOStockReport();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      if (this.queryParams.categoryIds.length > 0) {
        this.filterCategory = "";
        for (var i = 0; i < this.queryParams.categoryIds.length; i++) {
          let category = commonService.search(
            "id",
            this.queryParams.categoryIds[i],
            this.categoryList
          );
          this.filterCategory += category.name + ", ";
        }
      } else {
        this.filterCategory = "ALL";
      }
    },

    getPOStockReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPOStockReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.poStockReportList = res.data.poStockDetailList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getCategoriesByStatus() {
      return categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    showProducts() {
      // Clean query params
      this.productQueryParams.productCode = "";
      this.productQueryParams.productName = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productGroupName = "";
      this.selectedProductList = [];
      this.queryParams.productIds = [];
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct() {
      if (this.selectedProductList.length) {
        this.queryParams.productIds = [];
        this.selectedProductList.forEach((element) => {
          if (!this.queryParams.productIds.includes(element.id))
            this.queryParams.productIds.push(element.id);
        });
      }
      this.showProductListDialog = !this.showProductListDialog;
    },

    onSearchProduct() {
      this.productQueryParams.page = this.productpagination.page;
      this.productQueryParams.size = this.productpagination.rowsPerPage;
      this.getProductList();
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.productpagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productpagination.page,
          this.productpagination.rowsPerPage,
          this.productpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.producttotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    toggleAll() {
      if (this.selectedProductList.length) {
        this.selectedProductList = [];
      } else {
        this.selectedProductList = this.productList.slice();
      }
    },

    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    reprintStockReport(divName) {
      this.buttonLoading = true;
      purchaseOrderService
        .getAllPOStockReport(this.clonequeryParams)
        .then((res) => {
          this.allPOStockReportList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>